import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "../style.module.scss";
import { NutritionalFactsType } from "../types/RecipeProps";
import { Container } from "./Container";

export const NutritionFacts = (props: { nutritionalFacts: NutritionalFactsType }): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();
    const { t } = useTranslation();

    const { nutritionalFacts } = props;

    return (
        <Container>
            <div className={style.headerLabel}>
                <Typography
                    variant="h2"
                    color="dark"
                    size={jnjFullBranded ? "2xl" : "3xl"}
                    font="title"
                    weight={jnjFullBranded ? "400" : "500"}
                >
                    {t("Nutrition facts", { ns: "recipe" })}
                </Typography>
            </div>
            <div className={style.nutritionalFacts}>
                <Typography size="m" font="text" weight="600">
                    {t("Per Serving", { ns: "recipe" })}:
                </Typography>
                {nutritionalFacts?.calories && (
                    <Typography size="m" font="text" weight="400">
                        {nutritionalFacts?.calories} {t("calories", { ns: "recipe" })};
                    </Typography>
                )}
                {nutritionalFacts?.fat && (
                    <Typography size="m" font="text" weight="400">
                        {t("fat", { ns: "recipe" })} {nutritionalFacts?.fat}
                        {t("g", { ns: "recipe" })};
                    </Typography>
                )}
                {nutritionalFacts?.carbohydrates && (
                    <Typography size="m" font="text" weight="400">
                        {t("carbohydrates", { ns: "recipe" })} {nutritionalFacts?.carbohydrates}
                        {t("g", { ns: "recipe" })};
                    </Typography>
                )}
                {nutritionalFacts?.fibre && (
                    <Typography size="m" font="text" weight="400">
                        {t("fibre", { ns: "recipe" })} {nutritionalFacts?.fibre}
                        {t("g", { ns: "recipe" })};
                    </Typography>
                )}
                {nutritionalFacts?.iron && (
                    <Typography size="m" font="text" weight="400">
                        {t("iron", { ns: "recipe" })} {nutritionalFacts?.iron}
                        {t("g", { ns: "recipe" })};
                    </Typography>
                )}
                {nutritionalFacts?.protein && (
                    <Typography size="m" font="text" weight="400">
                        {t("protein", { ns: "recipe" })} {nutritionalFacts?.protein}
                        {t("g", { ns: "recipe" })}
                    </Typography>
                )}
            </div>
        </Container>
    );
};
